import { PropsWithChildren } from "react"
import omit from "lodash.omit"
import {
  Grid as RMWCGrid,
  GridRow as RMWCGridRow,
  GridCell as RMWCGridCell,
  GridProps as RMWCGridProps,
  GridRowProps as RMWCGridRowProps,
  GridCellProps as RMWCGridCellProps,
} from "@rmwc/grid"
import { styled, callCSSFn, StylePropsWithCSS, CSSFn } from "../styles"
import "@rmwc/grid/styles"

// eslint-disable-next-line react/require-default-props
type Style = { css?: CSSFn }

type GridProps = PropsWithChildren<RMWCGridProps> & Style
const GridComponent = (props: GridProps) => <RMWCGrid {...omit(props, `css`)} />
const StyledGrid = styled(GridComponent)((props: StylePropsWithCSS) => ({
  ...callCSSFn(props),
}))
export const Grid = (props: GridProps) => <StyledGrid {...props} />

type GridRowProps = PropsWithChildren<RMWCGridRowProps> & Style
const GridRowComponent = (props: GridRowProps) => <RMWCGridRow {...omit(props, `css`)} />
const StyledGridRow = styled(GridRowComponent)((props: StylePropsWithCSS) => ({ ...callCSSFn(props) }))
export const GridRow = (props: GridRowProps) => <StyledGridRow {...props} />

type GridCellProps = PropsWithChildren<RMWCGridCellProps> & Style
const GridCellComponent = (props: GridCellProps) => <RMWCGridCell {...omit(props, `css`)} />
const StyledGridCell = styled(GridCellComponent)((props: StylePropsWithCSS) => ({ ...callCSSFn(props) }))
export const GridCell = (props: GridCellProps) => <StyledGridCell {...props} />
GridCell.defaultProps = { css: undefined }
